import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ChartDataset, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { chartPalette } from '../../../_helpers/theming-engine/themes.const';

export class LineChartData {
  label: string;
  value: number;
}
@Component({
    selector: 'line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css'],
    standalone: false
})
export class LineChartComponent implements OnInit {
  @ViewChild(BaseChartDirective, { static: false }) baseChart: BaseChartDirective;
  @Input() data: LineChartData[];

  public lineChartData: ChartDataset[] = [];
  public lineChartLabels: string[] = [];

  public lineChartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
  };

  public lineChartLegend = false;
  public lineChartPlugins = [];
  public lineChartType = 'line';

  constructor() {
    this.lineChartData = [
      {
        data: [],
        label: '',
        borderColor: chartPalette['--primary'],
        backgroundColor: chartPalette['--primary-opaque-25'],
      }
    ];
  }

  ngOnInit() {
    this.setGraphData();
  }

  ngOnChanges(): void {
    this.setGraphData();
  }

  private setGraphData(): void {
    if (this.data) {
      setTimeout(() => {
        this.lineChartLabels = [];
        let dataPoints: number[] = [];

        this.data.forEach(item => {
          dataPoints.push(item.value);
          this.lineChartLabels.push(item.label);
        });

        this.lineChartData = [{
          data: dataPoints,
          label: '',
          borderColor: chartPalette['--primary'],
          backgroundColor: chartPalette['--primary-opaque-25'],
        }];

        this.baseChart?.chart?.update();
      }, 100);
    }
  }

}
